import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProdutosRoutingModule } from './produtos-routing.module';
import { PipeModule } from '../../pipe/pipe.module';
import { PartialModule } from '../../partial/partial.module';
import { ServicosPage } from 'src/app/pages/servico/servicos-page/servicos-page.component';
import { LoaderModule } from '../../loader/loader/loader.module';
import { ProdutoPartialModule } from '../produto-partial/produto-partial.module';
import { ModuloModule } from '../../modulo/modulo.module';

@NgModule({ 
  declarations: [
    ServicosPage 
  ],
  exports: [
    ServicosPage
  ],
  imports: [ 
    ModuloModule,  
    ProdutoPartialModule,
    LoaderModule,
    PipeModule,
    PartialModule,  
    CommonModule,
    ProdutosRoutingModule
  ]
})
export class ProdutosModule{}  
